import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { GameIntroScene } from "./GameIntro";
import { ChooseVehicleScene } from "./ChooseVehicleScene";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.ConstructionMaze;
        this.mainScene = ChooseVehicleScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "ConstructionMaze.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "ConstructionMaze.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "ConstructionMaze.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/ConstructionMazeGame/scenes/IntroductionScene.ts